module.exports = __webpack_public_path__ + "static/media/Chinese Mandarin_Yu Yan BG-13.e48d0140.png";